exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.document-field[data-v-16aa05bf] {\n  /* Your component styles go here */\n}\r\n", ""]);

// exports
